'use client';

import { c as _c } from "react/compiler-runtime";
import Script from 'next/script';
import { configPublic } from '@src/config.public';
const {
  amplitude
} = configPublic;
export const AmplitudeWebExperiment = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Script type="text/javascript" src={`https://cdn.amplitude.com/script/${amplitude.apiKey}.experiment.js`} strategy="beforeInteractive" async={true} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};